<template>
  <div class="judgeReDetail">
    <div class="searchBox">
      <div>【{{ $t('admin-judge/hasAmount') }} {{ product.review_num }}{{ product.review_num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }} / {{ $t('admin-judge/productAmount') }} {{ product.total }}{{ product.review_num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}】</div>
    </div>
    <div style="margin: 8px 0;">{{ product.pi_code || '' }}</div>
    <div>
      <img v-for="(item, index) in product.images" :key="index" :src="item.whole_image_url" class="img" style="cursor:pointer;" @click="preview(index)">
    </div>
    <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" label-align="left">
      <a-form-item
        :label="$t('user-productInfo-product/productName')"
        style="margin: 0;"
      >
        <span>{{ product.name_cn || '' }}</span>
      </a-form-item>
      <a-form-item
        :label="$t('user-productInfo-product/productEname')"
        style="margin: 0;"
      >
        <span>{{ product.name_en || '' }}</span>
      </a-form-item>
      <a-form-item
        :label="$t('user-productInfo-product/type')"
        style="margin: 0;"
      >
        <span>{{ product.category_cn || '' }}</span>
      </a-form-item>
      <a-form-item
        :label="$t('user-productInfo-product/typeEn')"
        style="margin-bottom: 20px;"
      >
        <span>{{ product.category_en || '' }}</span>
      </a-form-item>
    </a-form>
    <a-form layout="vertical">
      <a-form-item
        :label="$t('admin-judge/zdescription')"
        style="margin-bottom: 12px;height: auto;"
      >
        <div>{{ product.description_cn || '' }}</div>
      </a-form-item>
      <a-form-item
        :label="$t('admin-judge/edescription')"
        style="margin: 0;"
      >
        <div>{{ product.description_en || '' }}</div>
      </a-form-item>
    </a-form>
    <div><font color="#ed1c24">复评采取打分制，评分设置1.0到10.0之间，保留一位小数。</font></div>
    <div><font color="#ed1c24">{{ $t('admin-judge/tip8') }}</font></div>
    <footer>
      <a-button :class="{ disabled: !product.prev_id}" @click="go(-1)">
        {{ $t('admin-judge/pre') }}
      </a-button>
      <a-button
        type="primary"
        @click="go(0)"
      >
        {{ $t('admin-judge/awards') }}
      </a-button>
      <a-button :class="{ disabled: !product.next_id}" @click="go(1)">
        {{ $t('admin-judge/next') }}
      </a-button>
    </footer>
    <Modal
      :show-modal="showModal"
      :cancel-text="$t('register-verify/close')"
      :confirm-text="$t('register-verify/submit')"
      @cancel="showModal = false"
      @confirm="submit"
    >
      <div>
        <div>
          复评采取打分制，评分设置1.0到10.0之间，保留一位小数。
          <a-input-number v-model="score" style="width: 72px;" :max="10" :min="0" :step="0.1" :precision="1" />（满分10分）
        </div>
        <a-table
          :columns="columns"
          :data-source="dataSource"
          class="table"
          :pagination="false"
          row-key="level1"
          style="margin-top: 30px;"
          bordered
        />
      </div>
    </Modal>
    <Modal
      :show-modal="showModal2"
      @cancel="showModal2 = false"
      @confirm="go(tag, true);showModal2 = false"
    >
      <div>
        {{ $t('admin-judge/whetherNext') }}
      </div>
    </Modal>
    <PreviewImage v-if="previewVisible" :images="images" :index="imagesIndex" @closePreview="closePreview" />
  </div>
</template>

<script>
import { products } from '@/api/product'
import { updateReviewsProduct } from '@/api/judge'
import Modal from '@/views/components/Modal.vue'
import PreviewImage from '@/views/components/PreviewImage'

const columns = [
  { title: '0-29', dataIndex: 'level1' },
  { title: '30-59', dataIndex: 'level2' },
  { title: '60-69', dataIndex: 'level3' },
  { title: '70-79', dataIndex: 'level4' },
  { title: '80-89', dataIndex: 'level5' },
  { title: '90-100', dataIndex: 'level6' }
]

const dataSource = [
  {
    'level1': '落选',
    'level2': '不及格',
    'level3': '及格',
    'level4': '良好',
    'level5': '优秀',
    'level6': '非常优秀' }
]

export default {
  components: {
    Modal,
    PreviewImage
  },
  data() {
    return {
      columns,
      dataSource,
      product: {},
      showModal: false,
      showModal2: false,
      score: 0,
      tag: 0,
      images: [],
      imagesIndex: 0,
      previewVisible: false
    }
  },
  watch: {
    locale(e) {
      this.dataSource[0].level1 = this.$t('admin-judge/level1')
      this.dataSource[0].level2 = this.$t('admin-judge/level2')
      this.dataSource[0].level3 = this.$t('admin-judge/level3')
      this.dataSource[0].level4 = this.$t('admin-judge/level4')
      this.dataSource[0].level5 = this.$t('admin-judge/level5')
      this.dataSource[0].level6 = this.$t('admin-judge/level6')
    }
  },
  created() {
    this.dataSource[0].level1 = this.$t('admin-judge/level1')
    this.dataSource[0].level2 = this.$t('admin-judge/level2')
    this.dataSource[0].level3 = this.$t('admin-judge/level3')
    this.dataSource[0].level4 = this.$t('admin-judge/level4')
    this.dataSource[0].level5 = this.$t('admin-judge/level5')
    this.dataSource[0].level6 = this.$t('admin-judge/level6')

    this.getDetail()
  },
  methods: {
    getDetail() {
      // 统一使用 /products/{id} 接口获取初评作品详情
      products(this.$route.query.id).then(res => {
        // 统一使用 /products/{id} 接口，返回格式可能不同
        this.product = res.product || res
        this.score = this.product.score
      })
    },
    go(tag, bool) {
      switch (tag) {
        case -1: {
          if (this.product.prev_status && !bool) {
            this.tag = -1
            this.showModal2 = true
          } else if (this.product.prev_id) {
            this.$router.push({ query: { id: this.product.prev_id, user_id: this.$route.query.user_id }})
            this.getDetail()
          }
          break
        }
        case 0: {
          this.showModal = true
          break
        }
        case 1: {
          if (this.product.next_status && !bool) {
            this.tag = 1
            this.showModal2 = true
          } else if (this.product.next_id) {
            this.$router.push({ query: { id: this.product.next_id, user_id: this.$route.query.user_id }})
            this.getDetail()
          }
          break
        }
        default: break
      }
    },
    submit() {
      if (!this.score && this.score !== 0) {
        return this.$message.warning({ content: this.$t('admin-judge/tip5'), key: 'message', duration: 4 })
      }
      this.showModal = false
      const data = {
        score: this.score
      }
      updateReviewsProduct(this.$route.query.id, 2, data).then(res => {
        this.$message.success({ content: this.$t('admin-judge/scoreSuccess'), key: 'message', duration: 4 })
        if (res.status === 1) {
          this.$router.push({ path: '/admin/judgeReScore', query: { judgeConfirmTip: true }})
        }
      })
    },
    preview(index) {
      this.images = this.product.image.map(i => i.whole_image_url)
      this.imagesIndex = index
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
    }
  }
}
</script>
<style scoped>
  .judgeDetail {
    font-size: 14px;
  }

  .searchBox {
    padding: 17px 20px;
    background: #ffffff;
  }

  .img {
      width: 90px;
      height: 90px;
      margin-right: 10px;
  }

  .judgeDetail .ant-form .label {
    font-size: 14px;
  }

  footer{
    text-align: center;
    padding: 19px 0 39px;
  }

  footer button {
    margin-left: 16px;
  }
</style>
